const en = {
  items: [
    {
      slug: 'wedding-flowers',
      title: 'Wedding Bouquets & Decorations',
      short:
        'Bridal and bridesmaid bouquets, ceremony arches, aisle petals and reception florals designed around your palette and vision.',
      price: 'from $450',
    },
    {
      slug: 'balloon-arches',
      title: 'Balloon Arches & Installations',
      short:
        'Custom balloon arches, garlands and installations for any event — from pastel elegance to vibrant celebrations. Character balloons available.',
      price: 'from $75',
    },
    {
      slug: 'centerpieces',
      title: 'Event Centerpieces & Installations',
      short:
        'Tablescapes, hanging installations and photo walls built on site and styled down to the last detail.',
      price: 'from $85 / table',
    },
    {
      slug: 'themed-balloons',
      title: 'Themed Balloon Designs',
      short:
        'Custom themed setups for birthdays, baby showers, quinceañeras and special occasions. Character balloons and custom designs available.',
      price: 'Custom pricing',
    },
    {
      slug: 'custom-arrangements',
      title: 'Custom Floral Arrangements',
      short:
        'Hand-tied bouquets and vase arrangements for birthdays, anniversaries and just-because deliveries.',
      price: 'from $65',
    },
    {
      slug: 'celebration-combinations',
      title: 'Celebration Combinations',
      short:
        'Quinceañeras, baby showers and corporate events styled with both balloons and flowers for maximum impact.',
      price: 'Custom pricing',
    },
  ],
  page: {
    eyebrow: 'Services',
    title: 'Floral Design & Balloon Decorations',
    description:
      'Five ways we can help — from a single hand-tied bouquet to a full quinceañera with balloon arches and floral centerpieces.',
    newBadge: 'New',
    explore: 'Explore this service',
    categories: [
      {
        id: 'weddings',
        slug: 'wedding-flowers',
        title: 'Wedding & Special Events',
        kind: 'flowers',
        price: 'From $450+',
        items: [
          'Wedding bouquets & decorations',
          'Event centerpieces & installations',
          'Ceremony arches & installations',
        ],
      },
      {
        id: 'balloons',
        slug: 'balloon-arches',
        title: 'Balloon Decorations',
        kind: 'balloons',
        price: 'From $75+',
        items: [
          'Balloon arches & garlands',
          'Themed balloon installations',
          'Balloon centerpieces',
          'Character & custom balloon designs',
          'Event backdrop installations',
        ],
      },
      {
        id: 'custom',
        slug: 'custom-arrangements',
        title: 'Custom Arrangements',
        kind: 'flowers',
        price: 'From $65+',
        items: ['Hand-tied bouquets', 'Vase arrangements', 'Seasonal flowers'],
      },
      {
        id: 'celebrations',
        slug: 'celebration-combinations',
        title: 'Celebration & Corporate',
        kind: 'both',
        price: 'From $85+',
        items: [
          'Quinceañeras with balloon options',
          'Baby showers — balloons + flowers',
          'Birthday celebrations with themed balloons',
          'Corporate event styling',
        ],
      },
    ],
    sameDay: {
      title: 'Same-Day Service',
      text: 'Need something today? Rush orders and last-minute arrangements are available — flowers depend on seasonal stock, balloons can often be arranged within hours.',
      items: ['Rush orders available', 'Last-minute arrangements', 'Call for availability'],
      call: 'Call (240) 413-8201',
      whatsapp: 'WhatsApp us now',
    },
  },
}

const es: typeof en = {
  items: [
    {
      slug: 'wedding-flowers',
      title: 'Ramos de Novia y Decoraciones',
      short:
        'Ramos de novia y damas, arcos de ceremonia, pétalos de pasillo y flores para la recepción diseñados según su paleta y visión.',
      price: 'desde $450',
    },
    {
      slug: 'balloon-arches',
      title: 'Arcos e Instalaciones de Globos',
      short:
        'Arcos de globos personalizados, guirnaldas e instalaciones para cualquier evento — de la elegancia pastel a celebraciones vibrantes. Globos de personajes disponibles.',
      price: 'desde $75',
    },
    {
      slug: 'centerpieces',
      title: 'Centros de Mesa e Instalaciones de Evento',
      short:
        'Mesas decoradas, instalaciones colgantes y paredes fotográficas armadas en el lugar y cuidadas hasta el último detalle.',
      price: 'desde $85 / mesa',
    },
    {
      slug: 'themed-balloons',
      title: 'Diseños de Globos Temáticos',
      short:
        'Montajes temáticos para cumpleaños, baby showers, quinceañeras y ocasiones especiales. Globos de personajes y diseños a la medida.',
      price: 'Precio personalizado',
    },
    {
      slug: 'custom-arrangements',
      title: 'Arreglos Florales Personalizados',
      short:
        'Ramos hechos a mano y arreglos en florero para cumpleaños, aniversarios y entregas sorpresa.',
      price: 'desde $65',
    },
    {
      slug: 'celebration-combinations',
      title: 'Combinaciones de Celebración',
      short:
        'Quinceañeras, baby showers y eventos corporativos decorados con globos y flores para un impacto máximo.',
      price: 'Precio personalizado',
    },
  ],
  page: {
    eyebrow: 'Servicios',
    title: 'Diseño Floral y Decoraciones de Globos',
    description:
      'Cinco formas de ayudarle — desde un ramo hecho a mano hasta una quinceañera completa con arcos de globos y centros de mesa florales.',
    newBadge: 'Nuevo',
    explore: 'Ver este servicio',
    categories: [
      {
        id: 'weddings',
        slug: 'wedding-flowers',
        title: 'Bodas y Eventos Especiales',
        kind: 'flowers',
        price: 'Desde $450+',
        items: [
          'Ramos y decoraciones de boda',
          'Centros de mesa e instalaciones',
          'Arcos de ceremonia e instalaciones',
        ],
      },
      {
        id: 'balloons',
        slug: 'balloon-arches',
        title: 'Decoraciones de Globos',
        kind: 'balloons',
        price: 'Desde $75+',
        items: [
          'Arcos y guirnaldas de globos',
          'Instalaciones temáticas de globos',
          'Centros de mesa de globos',
          'Diseños de personajes y a la medida',
          'Fondos decorativos para eventos',
        ],
      },
      {
        id: 'custom',
        slug: 'custom-arrangements',
        title: 'Arreglos Personalizados',
        kind: 'flowers',
        price: 'Desde $65+',
        items: ['Ramos hechos a mano', 'Arreglos en florero', 'Flores de temporada'],
      },
      {
        id: 'celebrations',
        slug: 'celebration-combinations',
        title: 'Celebraciones y Corporativos',
        kind: 'both',
        price: 'Desde $85+',
        items: [
          'Quinceañeras con opciones de globos',
          'Baby showers — globos + flores',
          'Cumpleaños con globos temáticos',
          'Decoración de eventos corporativos',
        ],
      },
    ],
    sameDay: {
      title: 'Servicio el Mismo Día',
      text: '¿Lo necesita hoy? Aceptamos pedidos urgentes y arreglos de último momento — las flores dependen de la temporada, los globos a menudo se pueden preparar en pocas horas.',
      items: ['Pedidos urgentes disponibles', 'Arreglos de último momento', 'Llame para disponibilidad'],
      call: 'Llamar (240) 413-8201',
      whatsapp: 'Escríbanos por WhatsApp',
    },
  },
}

export const services = { en, es }
